import PageContainer from "../components/CommonComponents/PageContainer/PageContainer";
import {SportImagesDict} from "../utils/constants";
import { useTheme } from "../contexts/theme";
import Box from "@mui/material/Box";
import TransparentButtonSelection from "../components/CommonComponents/TransparentButtonSelection/TransparentButtonSelection";
import React, { useEffect, useRef, useState } from "react";
import {getCompleteDatasourceInfo, getMatchDayEvents, getStartingData} from "../queries/competitionMatchboardQueries";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import MatchDayEvent from "../components/CompetitionMatchboardComponents/MatchDayEvent/MatchDayEvent";
import FillEventPopup from "../components/CompetitionMatchboardComponents/FillEventPopup/FillEventPopup";
import {DataSource, Stream, Track} from "../types/dataSourceTypes";
import { Event } from "../types/eventTypes";
import { getMatchOptions } from "../queries/matchPageQueries";
import { Dayjs } from "dayjs";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { createStartJob } from "../queries/jobQueries";
import ErrorSnackBar from "../components/CommonComponents/ErrorSnackBar/ErrorSnackBar";
import {LoadError, SimpleFileDataSource, SimpleStreamDataSource, SupportedSports} from "../types/generic";
import { formatUTCDate } from "../utils/dateTimeutils";
import LoadingMachDayEventComponent from "../components/CompetitionMatchboardComponents/MatchDayEvent/LoadingMachDayEventComponent";
import axios from "axios";
import CompetitionSkeleton from "../components/CompetitionMatchboardComponents/CompetitionSkeleton";
import MatchDaysSkeleton from "../components/CompetitionMatchboardComponents/MatchDaysSkeleton";
import { Competition } from "../types/competitionTypes";
import {FormJob} from "../types/jobTypes";
import {getDefaultDataJob} from "../utils/jobUtils"


interface matchDayEvents {
    [matchDay: string]: Event[]
}

interface matchDayBlock {
    open: boolean;
    matchDay: number;
}

const defaultJobOptions = {
    name: '',
    tags: [],
    description: '',
    away_team: '',
    home_team: '',
    season: '',
    typeEvent: "football",
    event_start: new Date(),
    event_end: new Date(),
    championship: '',
    championship_name: "",
    dataSource: [{
        name: '',
        description: '',
        type: ''

    }]
}

const skeletons = [0, 1, 2, 3, 4, 5, 6, 7];
const competitionSkeletons = [0, 1, 2, 3];
const defaultJobData = getDefaultDataJob()
const defaultStreamDataSource = {type: "stream", description: '', name: '', id: '', end: new Date(), start: new Date(), protocol:'srt', url: '', tracks: [], pushPullButton: false}
const defaultFileDataSource = { name: '', description: '', path: '' }

export default function CompetitionMatchboard() {
    const theme = useTheme();
    const [competitions, setCompetitions] = useState<Competition[]>([]);
    const [selectedCompetition, setSelectedCompetition] = useState<string>("");
    const [selectedEvent, setSelectedEvent] = useState<Event>();
    const [streamDatasource, setStreamDatasource] = useState<Stream>(JSON.parse(JSON.stringify(defaultStreamDataSource)));
    const [fileDatasource, setFileDatasource] = useState<SimpleFileDataSource>(JSON.parse(JSON.stringify(defaultFileDataSource)));
    const [streamTracks, setStreamTracks] = useState<Track[]>([]);
    const [fileTracks, setFileTracks] = useState<Track[]>([]);
    const [typeMediaTracks, setTypeMediaTracks] = useState<string[]>([]);
    const [protocolOptions, setProtocolOptions] = useState<string[]>([]);
    const [competitionMatchDays, setCompetitionMatchDays] = useState<matchDayBlock[]>([]);
    const [matchDayAdditionalInfo, setMatchDayAdditionalInfo] = useState<{ [key: number]: { start: string, end: string, type: string } }>({})
    const [matchDayEvents, setMatchDayEvents] = useState<matchDayEvents>({});
    const [isJobFormOpen, setIsJobFormOpen] = useState(false);
    const [isEventFormOpen, setIsEventFormOpen] = useState(false);
    const [job, setJob] = useState<FormJob>(JSON.parse(JSON.stringify(defaultJobData)) as any);
    const [loadError, setLoadError] = useState<LoadError>({ message: '', error: false });
    const controllerRef = useRef<AbortController | null>(null);
    const [initialLoading, setInitialLoading] = useState<boolean>(false);
    const [matchDaysLoading, setMatchDaysLoading] = useState<boolean>(false);
    const initialLoadingRef = useRef<boolean>(false);
    const itemRefs = useRef<any[]>([]);

    const [dataSourcesInfoLoading, setDataSourcesInfoLoading] = useState<boolean>(false);

    const needButtonBackground = process.env.REACT_APP_SPORT === 'basketball'

    function updateTracks(nameDS: keyof Track, value: string | Dayjs | null, indexTrack?: number, type?: string) {
        if (indexTrack !== undefined) {
            const tempValue = value as ("audio" | "video" | "text") & string & { index: string; };
            const tempTracks = type === 'stream' ? [...streamTracks] : [...fileTracks];
            if (nameDS === 'info') {
                tempTracks[indexTrack].info.index = tempValue;
            } else {
                tempTracks[indexTrack][nameDS] = tempValue;
            }
            type === 'stream' ? setStreamTracks(tempTracks) : setFileTracks(tempTracks);
        }
    }

    function updateStreamDataSource(fieldName: keyof Stream, value: any)  {
        const tempStreamDatasource = { ...streamDatasource };
        (tempStreamDatasource as any)[fieldName] = value;
        setStreamDatasource(tempStreamDatasource)
    }

    function updateFileDataSource(fieldName: keyof SimpleFileDataSource, value: string) {
        const tempFileDatasource = { ...fileDatasource };
        tempFileDatasource[fieldName] = value;
        setFileDatasource(tempFileDatasource)
    }

    function onRemoveTrack(trackIndex: number, type?: string) {
        const tempTracks = type === 'stream' ? [...streamTracks] : [...fileTracks];
        tempTracks.splice(trackIndex, 1);
        type === 'stream' ? setStreamTracks(tempTracks) : setFileTracks(tempTracks);
    }

    function onAddTrack(type?: string) {
        const tempTracks = type === 'stream' ? [...streamTracks] : [...fileTracks];
        let idDataSource: string | undefined = '';
        if (type === 'stream' && streamDatasource) {
            idDataSource = streamDatasource.id
        } else if (type === 'file' && streamDatasource) {
            idDataSource = fileDatasource.id
        }
        const newTrack = {
            trackId: "",
            idDataSource: idDataSource,
            typeTrack: null,
            codec: "",
            codec_version: "",
            description: "",
            name: "",
            info: {
                index: ""
            }
        }
        tempTracks.unshift(newTrack);
        type === 'stream' ? setStreamTracks(tempTracks) : setFileTracks(tempTracks);
    }

    async function onCompetitionChange(competition: string) {
        if (selectedCompetition !== competition) {
            try {
                setMatchDaysLoading(true);
                setSelectedCompetition(competition);
                setCompetitionMatchDays([]);
                if (controllerRef.current) {
                    controllerRef.current.abort();
                }

                controllerRef.current = new AbortController();
                const { competitions, matchDays, additionalInfo, matchDayEvents, mostRecentMatchDayIndex } = await getStartingData(competition, controllerRef.current);
                setMatchDayAdditionalInfo(additionalInfo)
                setCompetitionMatchDays(matchDays.map((matchDay: number, index: number) => {
                    if (index === mostRecentMatchDayIndex) {
                        return { open: true, matchDay }
                    } return { open: false, matchDay }
                }));
                const tempMatchDayEvents: matchDayEvents = {};
                tempMatchDayEvents[matchDays[mostRecentMatchDayIndex]] = matchDayEvents;
                setMatchDayEvents(tempMatchDayEvents);
            } catch (error) {
                if (!axios.isCancel(error)) {
                    setLoadError({ error: true, message: 'Error Loading Competition Data' });
                }
            } finally {
                setMatchDaysLoading(false);
            }
        }
    }

    useEffect(() => {
        const loadData = async () => {
            if (!initialLoadingRef.current) {
                try {

                    initialLoadingRef.current = true;
                    setInitialLoading(true);
                    setMatchDaysLoading(true);
                    const { competitions, matchDays, additionalInfo, matchDayEvents, mostRecentMatchDayIndex } = await getStartingData();
                    scrollToItem(mostRecentMatchDayIndex);
                    const options = await getMatchOptions();
                    competitions.sort((comp1, comp2) => {
                        const season1 = parseInt(comp1.season);
                        const season2 = parseInt(comp2.season);

                        if (!isNaN(season1) && !isNaN(season2)) {
                            return season2 - season1;
                        }

                        return 0;
                    });

                    setCompetitions(competitions.map(comp => {
                        if (comp.season != null && !isNaN(parseInt(comp.season))) {
                            return { ...comp, name: `${comp.name} - ${comp.season}` };
                        }

                        return comp;
                    }));
                    setSelectedCompetition(competitions[0].id);
                    setTypeMediaTracks(options.typeMediaTrack);
                    setProtocolOptions(options.protocol);
                    setCompetitionMatchDays(matchDays.map((matchDay: number, index: number) => {
                        if (index === mostRecentMatchDayIndex) {
                            return { open: true, matchDay }
                        } return { open: false, matchDay }
                    }));
                    setMatchDayAdditionalInfo(additionalInfo)
                    const tempMatchDayEvents: matchDayEvents = {}
                    tempMatchDayEvents[matchDays[mostRecentMatchDayIndex]] = matchDayEvents
                    setMatchDayEvents(tempMatchDayEvents)

                } catch (e) {
                    setLoadError({ error: true, message: 'Error Loading Competitions Data' });
                } finally {
                    setInitialLoading(false);
                    setMatchDaysLoading(false);
                    initialLoadingRef.current = false;
                }
            }
        }
        loadData();
    }, []);

    useEffect(() => {
        async function loadData() {
            try {
                if(selectedEvent){
                    setDataSourcesInfoLoading(true)
                    setIsEventFormOpen(true);
                    const {streamDS, fileDS} = await getCompleteDatasourceInfo(selectedEvent.id)

                    if (streamDS){
                        setStreamDatasource(streamDS)
                        setStreamTracks(streamDS.tracks ? streamDS.tracks : [])
                    }else{
                        setStreamDatasource(JSON.parse(JSON.stringify(defaultStreamDataSource)))
                        setStreamTracks([])
                    }
                    if (fileDS){
                        setFileDatasource(fileDS)
                        setFileTracks(fileDS.tracks ? fileDS.tracks : [])
                    }else{
                        setFileDatasource(JSON.parse(JSON.stringify(defaultFileDataSource)))
                        setFileTracks([])
                    }
                    setDataSourcesInfoLoading(false)
                }

            } catch (error) {
                setLoadError({ error: true, message: 'Error Loading Event Data' });
                setDataSourcesInfoLoading(false)
            }
        }
        loadData();
    }, [selectedEvent]);

    async function onMatchDayClick(competition: string, matchDay: matchDayBlock) {
        try {
            const tempCompetitionMatchDays = [...competitionMatchDays];
            const compIndex = tempCompetitionMatchDays.findIndex(compMatchDay => compMatchDay.matchDay === matchDay.matchDay);
            if (!matchDay.open) {
                const tempMatchDayEvents = { ...matchDayEvents };
                tempCompetitionMatchDays[compIndex].open = true;
                setCompetitionMatchDays(tempCompetitionMatchDays);
                tempMatchDayEvents[matchDay.matchDay] = await getMatchDayEvents(competition, matchDay.matchDay);
                setMatchDayEvents(tempMatchDayEvents);
            } else {
                tempCompetitionMatchDays[compIndex].open = false;
                setCompetitionMatchDays(tempCompetitionMatchDays);
            }
        } catch (error) {
            setLoadError({ error: true, message: 'Error Loading Match Day Events' });
        }
    }

    async function onJobClick(event: Event) {
        try {
            const tempJob = { ...job }
            tempJob.events.id = event.id
            setIsJobFormOpen(true)
            setSelectedEvent(event);
            if (event && event.start_schedule) {
                tempJob.extraction_schedule = new Date(event.start_schedule);
            }
            setJob(tempJob);

        } catch (e) {
            setLoadError({ error: true, message: 'Error Loading Job Options' });
        }
    }


    async function onJobSubmit() {
        try {
            await createStartJob(job);
            if (selectedEvent) {
                const tempMatchDayEvents = { ...matchDayEvents };
                const matchDay = selectedEvent.matchday ? selectedEvent.matchday as number : -1;
                const eventIndex = tempMatchDayEvents[matchDay].findIndex(event => event.id === selectedEvent.id);
                tempMatchDayEvents[matchDay][eventIndex].scheduled = true
                setMatchDayEvents(tempMatchDayEvents);
                setLoadError({ error: true, message: 'Job created successfully' });
            }
        } catch (e) {
            setLoadError({ error: true, message: 'Error Scheduling Job' });
        } finally {
            handlePopupClose();
        }
    }

    function handlePopupClose() {
        setJob(JSON.parse(JSON.stringify(defaultJobData)));
        setSelectedEvent(undefined);
        setIsJobFormOpen(false);
        setIsEventFormOpen(false);
        setStreamDatasource(JSON.parse(JSON.stringify(defaultStreamDataSource)))
        setFileDatasource(JSON.parse(JSON.stringify(defaultFileDataSource)))
    }

    function setEventReady() {
        if (selectedEvent) {
            const tempMatchDayEvents = { ...matchDayEvents };
            const matchDay = selectedEvent.matchday ? selectedEvent.matchday as number : -1;
            const eventIndex = tempMatchDayEvents[matchDay].findIndex(event => event.id === selectedEvent.id);
            tempMatchDayEvents[matchDay][eventIndex].ready = true
            setMatchDayEvents(tempMatchDayEvents);
        }
    }

    const scrollToItem = (index: number) => {
        itemRefs.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    return (
        <PageContainer>
            <Box
                style={{
                    width: "100%",
                    height: "100%",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    backgroundColor: theme.palette.blue
                }}
            >
                <Box style={{
                    paddingTop: theme.spacing.none,
                    paddingBottom: theme.spacing.none,
                    flex: 1,
                    color: theme.palette.white,
                    width: '100%',
                    overflowY: "auto",
                    backgroundImage: `url(${SportImagesDict.Matchboard[process.env.REACT_APP_SPORT as SupportedSports]})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}>
                    {!initialLoading ?
                        <TransparentButtonSelection
                            valueField={'id'}
                            labelField={'name'}
                            options={competitions}
                            value={selectedCompetition}
                            onChange={onCompetitionChange}
                            needButtonBackground={needButtonBackground}
                        /> :
                        <CompetitionSkeleton skeletonNumber={4} />
                    }
                    <Grid container sx={{ margin: '0 auto', paddingTop: theme.spacing.md, paddingBottom: theme.spacing.md }}>
                        {matchDaysLoading && <MatchDaysSkeleton skeletonNumber={20}></MatchDaysSkeleton>}
                        {!matchDaysLoading && competitionMatchDays.map((dayBlock, dayIndex) => (
                            <Grid item xs={12} key={dayIndex} ref={(el) => (itemRefs.current[dayIndex] = el)}>
                                <Grid
                                    container
                                    alignItems={'center'}
                                    height={'50px'}
                                    onClick={() => onMatchDayClick(selectedCompetition, dayBlock)}
                                    sx={{
                                        backgroundColor: theme.palette.blurredBlue,
                                        borderBottom: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
                                        borderTop: dayIndex === 0 ? `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}` : ''
                                    }}
                                >
                                    <Grid item xs={4}>
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                fontWeight: theme.fontWeights.title,
                                                color: theme.palette.white,
                                                marginBottom: theme.spacing.xs,
                                                borderBottom: `${theme.border.width} ${theme.border.type} ${theme.palette.white}`
                                            }}
                                        >
                                            {dayBlock.matchDay > -1 ? (matchDayAdditionalInfo[dayBlock.matchDay].type ? matchDayAdditionalInfo[dayBlock.matchDay].type : "Match day ") + " " + dayBlock.matchDay : "No match day info"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} display={'flex'} justifyContent={'center'}>
                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                fontWeight: theme.fontWeights.title,
                                                color: theme.palette.white,
                                                marginBottom: theme.spacing.xs,
                                                borderBottom: `${theme.border.width} ${theme.border.type} ${theme.palette.white}`
                                            }}
                                        >
                                            {dayBlock.matchDay > -1
                                                ? `${formatUTCDate(matchDayAdditionalInfo[dayBlock.matchDay].start, false, false)} / ${formatUTCDate(matchDayAdditionalInfo[dayBlock.matchDay].end, false, false)}`
                                                : ""}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} display={'flex'} justifyContent={'end'}>
                                        {dayBlock.open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                                    </Grid>
                                </Grid>
                                {dayBlock.open && !matchDayEvents[dayBlock.matchDay] && <Grid item xs={12} container>
                                    {skeletons.map((skeleton, skeletonIndex) => (
                                        <Grid item xs={12} lg={6} sx={{
                                            borderBottom: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
                                            borderRight: (skeletonIndex % 2 === 0) ? `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}` : '',
                                            paddingTop: theme.spacing.sm,
                                            paddingBottom: theme.spacing.sm,
                                            backgroundColor: theme.palette.blurredBlue
                                        }}>
                                            <LoadingMachDayEventComponent />
                                        </Grid>
                                    ))}
                                </Grid>
                                }
                                {dayBlock.open && matchDayEvents[dayBlock.matchDay] && <Grid item xs={12} container>
                                    {matchDayEvents[dayBlock.matchDay].map((event, eventIndex) => (
                                        <Grid key={event.id} item xs={12} lg={6} sx={{
                                            borderBottom: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}`,
                                            borderRight: (eventIndex % 2 === 0) ? `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.white}` : '',
                                            paddingTop: theme.spacing.sm,
                                            paddingBottom: theme.spacing.sm,
                                            backgroundColor: theme.palette.blurredBlue
                                        }}>
                                            <MatchDayEvent
                                                onStartJobClick={() => onJobClick(event)}
                                                onUpdateClick={() => setSelectedEvent(event)}
                                                key={"MatchDayEvent" + eventIndex} event={event}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>}
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
            {(isJobFormOpen || streamTracks) && selectedEvent && <FillEventPopup
                isOpen={selectedEvent !== undefined}
                handleClose={handlePopupClose}
                streamTracks={streamTracks}
                fileTracks={fileTracks}
                typeMediaTrack={typeMediaTracks}
                updateStreamTracks={(nameDS, value, indexTrack) => updateTracks(nameDS, value, indexTrack, 'stream')}
                updateFileTracks={(nameDS, value, indexTrack) => updateTracks(nameDS, value, indexTrack, 'file')}
                updateStreamDataSource={updateStreamDataSource}
                streamDataSource={streamDatasource}
                fileDataSource={fileDatasource}
                protocolOptions={protocolOptions}
                onRemoveFileTrack={(trackIndex) => onRemoveTrack(trackIndex, 'file')}
                onRemoveStreamTrack={(trackIndex) => onRemoveTrack(trackIndex, 'stream')}
                onAddFileTrack={() => onAddTrack('file')}
                onAddStreamTrack={() => onAddTrack('stream')}
                job={job}
                setJob={setJob}
                isJobFormOpen={isJobFormOpen}
                onJobSubmit={onJobSubmit}
                isEventFormOpen={isEventFormOpen}
                setEventReady={setEventReady}
                event={selectedEvent}
                updateFileDataSource={updateFileDataSource}
                popUpTitle={selectedEvent.name + " " + formatUTCDate(selectedEvent.start_schedule)}
                dataSourcesLoading={dataSourcesInfoLoading}
            />}
            <ErrorSnackBar autoHideDuration={5000} open={loadError.error} setClose={() => setLoadError({ message: '', error: false })} errorMessage={loadError.message} />
        </PageContainer>
    )

}